import { useCallback, useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'
import { listTagsKey, listTagsService } from '../../../services/place'

import clsx from 'clsx'

import useQueryParams from '~/hooks/useQuery'
import { Button as ButtonNative } from '../../../../../components/Buttons'
import { Flex, Skeleton, Text } from '@vtex/shoreline'

import s from '../styles.module.css'

interface SelectTagsProps {
  selectedTags: string[] | null
  setSelectedTags: (tags: string[] | null) => void
}

export function SelectTags({ selectedTags, setSelectedTags }: SelectTagsProps) {
  const { t } = useAPPTranslation()
  const publisherId = useQueryParams().get('rmid')

  const { data, isLoading } = useQuery({
    queryKey: [listTagsKey, publisherId],
    queryFn: async () => {
      const response = await listTagsService({ publisher_id: publisherId })
      return response.data
    }
  })

  const tags = useMemo(() => data?.tags, [data?.tags])

  const handleTagClick = useCallback(
    (tag: string) => {
      if (selectedTags?.includes(tag)) {
        setSelectedTags(selectedTags.filter(t => t !== tag))
      } else {
        setSelectedTags(selectedTags ? [...selectedTags, tag] : [tag])
      }
    },
    [selectedTags, setSelectedTags]
  )

  return (
    <Flex direction="column" className={clsx(s.flexOne, s.overflowAuto)}>
      <Text variant="emphasis">
        {t('rm:campaign.create.ScreenGroups.Modal.selectScreens')}
      </Text>
      {isLoading ? (
        <Skeleton width="100%" height="100px" />
      ) : tags?.length > 0 ? (
        <Flex gap="var(--sl-space-2)" wrap="wrap">
          {tags?.map((tag: string) => (
            <ButtonNative
              key={tag}
              template="transparentOutlined"
              onClick={() => handleTagClick(tag)}
              className={selectedTags?.includes(tag) ? 'active' : ''}
            >
              {tag}
            </ButtonNative>
          ))}
        </Flex>
      ) : (
        <Text>{t('rm:campaign.create.ScreenGroups.Modal.noTags')}</Text>
      )}
    </Flex>
  )
}
